export enum Currency {
  ALL = "All",
  EUR = "EUR",
  USD = "USD",
  GBP = "GBP",
  BAM = "BAM",
  RSD = "RSD",
  AOA = "AOA",
  BWP = "BWP",
  GHS = "GHS",
  UGX = "UGX",
  NAD = "NAD",
}
